import React from 'react';
import { ValueOf } from 'global';
import { Box } from '@mui/material';
import { useSelector } from 'react-redux';
import { Controller, useFormContext } from 'react-hook-form';
import { FormInputSelect, InputField } from 'components/form';
import { deskingSelectors } from '../../../../model';
import { FormSectionHeader } from '../../../components';
import { creditAppSelectors } from '../../../../../../redux/creditAppReducer';
import { ContactForm, FinanceProgramFormValues, FormSectionProps } from '../../../../types';

export const Contact = ({ sectionName, onContactChanged }: FormSectionProps) => {
  const { control, setValue } = useFormContext<FinanceProgramFormValues>();

  const contacts = useSelector(creditAppSelectors.contacts);
  const contactSelectOptions = useSelector(creditAppSelectors.contactSelectOptions);
  const isSectionOpen = useSelector((state: any) => deskingSelectors.isSectionOpen(state, sectionName));
  const isSectionCollapsed = useSelector((state: any) => deskingSelectors.isSectionCollapsed(state, sectionName));

  const handleChangeContact = (value: string) => {
    const contact = contacts.find((owner: any) => owner.ownerPgId === value);

    const dependentFields: (keyof ValueOf<Pick<FinanceProgramFormValues, 'contact'>, 'contact'>)[] = [
      'email',
      'phone',
      'fullName',
      'title',
    ];

    const customerToSet: ContactForm = dependentFields.reduce(
      (acc, key) => {
        acc[key] = contact?.[key] || '';
        return acc;
      },
      { selectedContact: value } as ContactForm
    );

    setValue('contact', customerToSet);
    onContactChanged?.(customerToSet);
  };

  return (
    <Box className="section">
      <FormSectionHeader
        name="Customer"
        sectionName={sectionName}
        isSectionOpen={isSectionOpen}
        isSectionCollapsed={isSectionCollapsed}
      />

      <Box className="sectionFields">
        <Controller
          control={control}
          name="contact.selectedContact"
          render={({ field }) => (
            <FormInputSelect
              variant="standard"
              label="Select contact"
              options={contactSelectOptions}
              {...field}
              onChange={handleChangeContact}
            />
          )}
        />

        <InputField control={control} label="Customer Name" name="contact.fullName" inputProps={{ disabled: true }} />

        <Box className="row">
          <InputField label="Email" control={control} name="contact.email" inputProps={{ disabled: true }} />

          <InputField control={control} label="Phone Number" name="contact.phone" inputProps={{ disabled: true }} />
        </Box>
      </Box>
    </Box>
  );
};
